export default "__VITE_ASSET__BzW6_We1__"